import { Inject, Injectable } from '@angular/core';
import { CurrentStateService } from '@ddv/behaviors';
import { FeatureFlagService } from '@ddv/entitlements';
import { ApiExecutorService, ApiServices } from '@ddv/http';
import { Observable, switchMap } from 'rxjs';

import { DashboardNote } from '../models/dashboard-note';

@Injectable()
export class DashboardNotesService {
    private clientCode = '';

    constructor(
        private readonly currentStateService: CurrentStateService,
        @Inject(ApiServices.ddvApi) private readonly ddvApiExecutor: ApiExecutorService,
        private readonly featureFlagService: FeatureFlagService,
    ) {
        this.currentStateService.clientCode$.subscribe({
            next: (clientCode) => this.clientCode = clientCode,
        });
    }

    fetchDashboardNote(dashboardId: string | number): Observable<DashboardNote | undefined> {
        return this.ddvApiExecutor.invokeServiceWithParams<DashboardNote>(this.clientCode, `dashboards/${dashboardId}/note`);
    }

    createDashboardNote(
        dashboardId: string,
        dashboardNote: DashboardNote,
        dashboardClientCode?: string, // this should be removed after we have fully migrated dashboards
    ): Observable<DashboardNote> {
        let url = `dashboards/${dashboardId}/note`;
        return this.featureFlagService.isFlagEnabled('use-aws-for-dashboards', this.clientCode).pipe(
            switchMap((isFlagEnabled) => {
                if (!isFlagEnabled) {
                    url += '?useDashboardClientCode=true';
                }
                if (dashboardClientCode) {
                    url += `&dashboardClientCode=${dashboardClientCode}`;
                }
                return this.ddvApiExecutor.invokeServiceWithBody<DashboardNote>(this.clientCode, url, 'POST', dashboardNote);
            }),
        );
    }

    updateDashboardNote(dashboardId: string, dashboardNote: DashboardNote): Observable<DashboardNote> {
        return this.ddvApiExecutor.invokeServiceWithBody<DashboardNote>(this.clientCode, `dashboards/${dashboardId}/note`, 'PUT', dashboardNote);
    }

    deleteDashboardNote(dashboardId: string): Observable<void> {
        return this.ddvApiExecutor.invokeServiceWithBody(this.clientCode, `dashboards/${dashboardId}/note`, 'DELETE', null);
    }
}
